import { useParams } from 'react-router-dom';
import { useCallRecordDetail } from 'flow/hooks/api/useCallRecordDetail';
import { useCallRecordWithCtiContact } from 'flow/hooks/useCallRecordWithCtiContact';
import { CallRecordKey } from 'flow/types/EntityKeys';
import {
    CallRecordDetailHeaderSkeleton,
    CallRecordDetailContentSkeleton,
} from './CallRecordDetailSkeleton';
import CallRecordDetailContent from './CallRecordDetailContent';
import HeaderCallRecordDetail from './HeaderCallRecordDetail';
import {
    PageType,
    SegmentContextType,
} from 'flow/components/call-history-v2/types';
import { DetailPageTabKey } from './TabsCallRecordDetail';

interface Props {
    pageType: PageType;
    segmentContext: SegmentContextType;
    initialTab?: DetailPageTabKey;
    tabsHidden?: DetailPageTabKey[];
}

const CallHistoryDetailPageV2 = ({
    pageType,
    segmentContext,
    initialTab,
    tabsHidden,
}: Props) => {
    const { callRecordKey } = useParams<{
        callRecordKey: CallRecordKey;
    }>();

    const {
        callRecord: rawCallRecord,
        ticketKey,
        ticketScopeIsResolved,
        extendedTranscription,
    } = useCallRecordDetail(callRecordKey, 'page');
    const callRecord = useCallRecordWithCtiContact(rawCallRecord);

    if (!callRecord) {
        return <Skeleton initialTab={initialTab} />;
    }

    return (
        <div className="flex h-full w-full flex-col overflow-hidden bg-white antialiased">
            <HeaderCallRecordDetail
                callRecordKey={callRecordKey}
                ticketKey={ticketKey}
                ticketScopeIsResolved={ticketScopeIsResolved}
                subject={extendedTranscription?.subject}
                pageTypeDemandsBackButton={pageType !== 'personal'}
                segmentContext={segmentContext}
            />
            <main className="flex min-h-0 flex-1 flex-col">
                <CallRecordDetailContent
                    callRecordKey={callRecordKey}
                    ticketKey={ticketKey}
                    ticketAccessDenied={undefined}
                    extendedTranscription={extendedTranscription}
                    pageType={pageType}
                    segmentContext={segmentContext}
                    initialTab={initialTab}
                    tabsHidden={tabsHidden}
                    contentClassName="ps-4 pe-2"
                    scrollableId="main-scrollable-div"
                />
            </main>
        </div>
    );
};

export default CallHistoryDetailPageV2;

const Skeleton = ({ initialTab }: { initialTab?: DetailPageTabKey }) => (
    <div className="flex h-full w-full flex-col overflow-hidden bg-white antialiased">
        <CallRecordDetailHeaderSkeleton />
        <main className="flex min-h-0 flex-1 flex-col">
            <CallRecordDetailContentSkeleton initialTab={initialTab} />
        </main>
    </div>
);
